define('OutSystems/ClientRuntime/modules/PersistentKeyValue/PersistentKeyValueInitializer',["require", "exports", "tslib", "../../Logger", "./PersistentKeyValueTableInfo"], function (require, exports, tslib_1, Logger, PersistentKeyValueTableInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PersistentKeyValueInitializer = {
        isNeeded: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, tx.existsTable(PersistentKeyValueTableInfo_1.default)];
                    case 1: return [2, !(_a.sent())];
                }
            });
        }); },
        run: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.trace(this, "Running initializer for persistent key value info table.");
                        return [4, tx.createTable(PersistentKeyValueTableInfo_1.default)];
                    case 1:
                        _a.sent();
                        Logger.trace(this, "Initializer for entity persistent key value info table ran successfuly.");
                        return [2];
                }
            });
        }); },
    };
    exports.default = PersistentKeyValueInitializer;
});
//# sourceMappingURL=PersistentKeyValueInitializer.js.map;
